module.exports = __webpack_public_path__ + "img/plus.913f9311.svg";